module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Substract-263056ab18d619be66bc7f93f8d8f4b8.svg";